/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-07-20 15:05:48
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-07-20 15:14:16
 */

export default {
  path: 'preview/pdf',
  component: () => import(/* webpackChunkName: "live-list" */ '@/pages/preview/pdf'),
  meta: {title:'预览PDF', isShow: false}
}